module.exports = __webpack_public_path__ + "img/A58A0134.db969405.jpg";